import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 路由切换自动置顶组件
 * 解决 SPA 页面跳转时残留上一页面滚动条位置的问题
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior,
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;

